import { IntlShape } from 'react-intl';
import { FormValues } from '../MetricTemplates/EditMetricTemplateModal';

export const getBehaviorHintText = (intl: IntlShape, behavior: FormValues['behavior']): string => {
	switch (behavior) {
		case 'average':
			return intl.formatMessage({ id: 'form.metric.behavior.hint.average' });
		case 'proportion':
			return intl.formatMessage({ id: 'form.metric.behavior.hint.proportion' });
		case 'sum':
			return intl.formatMessage({ id: 'form.metric.behavior.hint.sum' });
		default:
			return intl.formatMessage({ id: 'form.metric.behavior.hint.latest' });
	}
};

export const getTrendComparisonHintText = (intl: IntlShape, behavior: FormValues['defaultTrendComparison']): string => {
	switch (behavior) {
		case 'absolute':
			return intl.formatMessage({ id: 'form.metric.trend-comparison.hint.absolute' });
		default:
			return intl.formatMessage({ id: 'form.metric.trend-comparison.hint.relative' });
	}
};
